import { ActionReducer, Action } from '@ngrx/store';
import { initialCompanyVoteResultListState, ICompanyVoteResultListState } from '../states/company-vote-result-list.state';
import { ECompanyVoteResultListActions, SetSearchFilter, SetPagination, SetSort } from '../actions/company-vote-result-list.actions';

export const companyVoteResultListReducers: ActionReducer<ICompanyVoteResultListState, Action<string>> = (
  state = initialCompanyVoteResultListState,
  action: Action<string>
) => {
  switch (action.type) {
    case ECompanyVoteResultListActions.SetSearchFilter: {
      const typedAction = action as SetSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1
      };
    }

    case ECompanyVoteResultListActions.SetPagination: {
      const typedAction = action as SetPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case ECompanyVoteResultListActions.SetSort: {
      const typedAction = action as SetSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case ECompanyVoteResultListActions.ClearFilters: {
      return {
        ...initialCompanyVoteResultListState
      };
    }

    default:
      return state;
  }
};
